import View from "../../../Nav/Js/views/CreditDetailView";
import components from "./components.js";
components.define("js-PopupCreditPopup", View);